import type { CheckoutConfig } from '#types/config/pages/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    itemSelected: 'bg-brand-2',
    legalCheckbox: 'mt-2 body-4'
  },
  legalCheckboxStep: 'shipping',
  contactFieldsOrder: (() => ['phone', 'email']) as unknown as CheckoutConfig['contactFieldsOrder']
} satisfies RecursivePartial<CheckoutConfig>
